import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store, Select } from '@ngxs/store';
import { Observable, Subscription, throwError } from 'rxjs';

import { EventService, OrderService, ToastService } from '../../core/services';
import { BasicFilter, City, SystemStatistics, UserProfile } from '../../core/models';
import { catchError, filter, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { eventImage, isCorporateUser, userImage } from '../../core/helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CouponModalComponent } from '../../shared';

@Component({
    selector: 'gs-dashboard',
    templateUrl: './dashboard.component.html',
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  // Also accepts a function like our select method. It can select only specific parts of the state.
  @Select(state => state.auth.isDashboardFirstDisplay) isDashboardFirstDisplay$: Observable<boolean>;
  @Select(state => state.staticData.systemStatistics) systemStatistics$: Observable<SystemStatistics>;

  // Reads the name of the state from the state class; the variable name doesn't have to match. It only returns the FULL state.
  //@Select(AuthState) isDashboardFirstDisplay$: Observable<boolean>;
  // Reads the name of the state from the parameter; the name of the variable must match state name. It only returns the FULL state.
  // @Select() user$: Observable<AuthStateModel>;

  Math = Math;

  user: UserProfile;
  events: any[];
  eventCount: number = 0;
  orders: any[];
  orderCount: number = 0;

  cities: City[] = [];

  private subscriptions: Subscription[] = [];

  get userFirstName(): string {
    return this.user?.name?.split(' ').shift();
  }

  get userImageUrl(): string {
    return userImage(this.user?.image);
  }

  get profileCompleteness(): number {
    return 0 +
      (this.user?.firstName ? 10 : 0) +
      (this.user?.lastName ? 10 : 0) +
      (this.user?.birthDate ? 20 : 0) +
      (this.user?.gender ? 10 : 0) +
      (this.user?.cityId ? 10 : 0) +
      (this.user?.phone ? 10 : 0) +
      (this.user?.hobbies?.length ? 10 : 0) +
      (this.user?.image ? 20 : 0);
  }

  constructor(
    private eventService: EventService,
    private orderService: OrderService,
    private toastService: ToastService,
    private modalService: NgbModal,
    private store: Store,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.store.select<UserProfile>(state => state.auth.user)
        .subscribe(user => {
          this.user = user;
          if (user) {
            if (isCorporateUser(this.user)) {
              this.router.navigate(['/corporate/dashboard']);
              return;
            }

            this.getEvents();
            this.getOrders();
          }
        }),

      this.store.select<City[]>(state => state.staticData.cities)
        .pipe(filter(x => !!x))
        .subscribe((data: City[]) => {
          this.cities = data;
        }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getCity(cityId: number): City {
    return this.cities?.find(x => x.id === cityId);
  }

  getEvents() {
    this.subscriptions.push(
      this.eventService.getEvents({ number: 0, size: 3 } as BasicFilter)
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          response.items.forEach((x) => {
            x.image = eventImage(x);
          });

          this.events = response.items;
          this.eventCount = response.totalCount;
        })
    );
  }

  getOrders() {
    this.subscriptions.push(
      this.orderService.getOrders()
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          this.orders = response;
          this.orderCount = response.length;
        })
    );
  }

  onCoupon() {
    const modalRef = this.modalService.open(CouponModalComponent, { backdrop: 'static', });
    modalRef.componentInstance.title = 'Aplica un card cadou GiftShare';
  }
}
